import React from 'react';
import style from './SquareDelete-styles.module.scss';
import { IconButton } from '@material-ui/core';
import Delete from '../../assets/svgComponent/delete';
import SButton from '../SButton/SButton';

const SquareDelete = ({ onPress, children, ...props }) => {
  return (
    <SButton variant={"tertiary"} onClick={onPress} className={style['button-container']} style={{ width: '3.7rem', height: '3.7rem' }} {...props}>
      <Delete style={{ color: '#ff535a' }} />
    </SButton>
  );
};

export default SquareDelete;
